// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oUky","colBig":"styles_colBig__1qVni","colSmall":"styles_colSmall__2AMwy","shopifyNameWrapper":"styles_shopifyNameWrapper__2nmyp"};